import React from 'react'
import SimpleModal from 'components/Modal/SimpleModal'
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'antd'
import handshake from 'assets/images/handshake.png'
import MultiStepModal from '../../../../routes/Questioner'
import ShowDailyQuestion from '../../../../routes/DailyQuestion'
const QuestionaireModal = () => {

 

    const dispatch = useDispatch()
    const signupProps = useSelector(state => state.signUp)
    const { questionnaireModelVisible, thanksModalSurveyVisible, showDailyQuestionModal } = signupProps
    const styles = {
        greybg: {
            backgroundColor: '#f9f9f9'
        }
    }

    const closethisAndOpenQuestions = () => {
        dispatch({
            type: 'questionnaire_modal'
        })
        dispatch({
            type: 'question-multistep-modal'
        })
    }

    const startDailyQuestion = () => {
        console.log("========== start Daily Question ");
        dispatch({
            type: 'thanks_modal_completion_of_survey'
        })
        dispatch({
            type: 'show_daily_question_modal'
        })
    }


    return (
        <>
            <SimpleModal

                modalFor="questionnaire_modal"
                visible={questionnaireModelVisible}
                width={600}
                closable={false}
                className="questionnaire-modal"
                style={{ top: 20 }}
                maskClosable={false}
            >
                <img src={handshake} alt="" />
                <div className="gx-p-3" style={styles.greybg}>
                    <h5 className="gx-blue-font gx-mb-2">Thank you for choosing Collab-Care.</h5>
                    <p>
                        Please answer a few short questions about the care recipient. Answer all questions from the care recipient’s perspective. Once completed, you will have access to the portal and your personalised care plan!
            </p>
                </div>
                <div className="gx-p-3 gx-d-flex gx-justify-content-end">
                    {/* <Checkbox onChange={onchange}>I Accept the Collab-Care term of servicess</Checkbox> */}
                    <Button className="gx-mb-0 gx-pt-0 "  type="primary" onClick={() => closethisAndOpenQuestions()}>Start</Button>
                </div>

            </SimpleModal>

            <MultiStepModal />

            <SimpleModal

                modalFor="thanks_modal_completion_of_survey"
                visible={thanksModalSurveyVisible}
                width={600}
                closable={false}
                className="questionnaire-modal"
                style={{ top: 20 }}
                maskClosable={false}
            >
                <img src={handshake} alt="" />
                <div className="gx-p-3" style={styles.greybg}>
                    <h5 className="gx-blue-font gx-mb-2">Thank you for completing the care needs and health needs section.</h5>
                    <p>
                    Smartnurse is developing your care plan. Please begin the daily report some questions may be repeated this time only.
                    </p>
                </div>
                <div className="gx-p-3 gx-d-flex gx-justify-content-end">
                    <Button className="gx-mb-0 gx-pt-0" type="primary" onClick={() => startDailyQuestion()}>Start</Button>
                </div>

            </SimpleModal>
            <SimpleModal
                title="Questionnaire"
                modalFor="show_daily_question_modal"
                maskClosable={false}
                visible={showDailyQuestionModal}
                width={630}
                closable={false}
                className="questionnaire-modal"
                style={{ top: 20 }}
            >
                <ShowDailyQuestion />
            </SimpleModal>
        </>
    )
}

export default QuestionaireModal
